import { useApi } from './use-api-call';

export const useSearchUserProfileApi = () =>
    useApi<{
        userProfiles: UserProfileDTO[];
        allowEdit: boolean;
    }>('/user-profile/search-user-profile');

export const useGetUserProfileApi = () =>
    useApi<{ userProfile: UserProfileDTO; allowEdit: boolean }>('/user-profile/get-user-profile/{id}');

export const useGetUserProfileByUserNameApi = () =>
    useApi<{ userProfile: UserProfileDTO; allowEdit: boolean }>('/user-profile/get-user-profile-by-username/{userName}');

export const useSaveUserProfileApi = () => useApi<{ userProfile: UserProfileDTO }>('/user-profile/save-user-profile');

export const useDeleteUserProfileApi = () => useApi('/user-profile/delete-user-profile/{id}');

export interface UserProfileDTO {
    id: number;
    userName: string;
    fullName?: string;
    company?: string;
    phoneNumber?: string;
    address?: string;
    city?: string;
    country?: string;
    postalCode?: string;
    smsNotifications: boolean;
    createdAt: string;
    updatedAt?: string;
}

